<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="成果申报申请" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button type="primary" @click="downLoadImportModel">下载承诺书</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="申报表编号">
                                            <a-input ref="cgsbbbh" v-model="editData.cgsbbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报日期" required>
                                            <a-date-picker ref="sbrq" v-model="editData.sbrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报年份">
                                            <FGDictSelectCN ref="sbnf" dictNo="P0002" v-model="editData.sbnf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报单位编号">
                                            <a-input ref="sbdwbh" v-model="editData.sbdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报单位名称">
                                            <a-input ref="sbdwmc" v-model="editData.sbdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="咨询单位备案编号" required>
                                            <a-input ref="babh" v-model="editData.babh" :maxLength="50" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="地址" required>
                                            <a-input ref="xxdz" v-model="editData.xxdz" :maxLength="100" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="邮政编码" required>
                                            <a-input ref="yzbm" v-model="editData.yzbm" :maxLength="10" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系人1" required>
                                            <a-input ref="lxr" v-model="editData.lxr" :maxLength="20" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系电话1" required>
                                            <a-input ref="lxdh" v-model="editData.lxdh" :maxLength="20" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系人2">
                                            <a-input ref="lxr1" v-model="editData.lxr1" :maxLength="20" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="联系电话2">
                                            <a-input ref="lxdh1" v-model="editData.lxdh1" :maxLength="20" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" :precision="2" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入日期">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" v-if="editData.djzt === '否决'">
                                        <a-form-item label="(合规审核)审核意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="shyj" :rows="3" v-model="editData.shyj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" :maxLength="400" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item
                                            label="江苏省工程咨询协会第五届会员单位证书"
                                            :label-col="{ span: 12 }"
                                            :wrapper-col="{ span: 12 }"
                                            required
                                        >
                                            <UploadButton :state="state" field="dwzs" :attachCfg.sync="attachCfg" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    上传单位证书截图,文件需要命名为【江苏省工程咨询协会第五届会员单位证书】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="承诺书" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" required>
                                            <UploadButton :state="state" field="cns" :attachCfg.sync="attachCfg" />
                                            <a-tooltip style="margin-left: 10px;color: red">
                                                <template slot="title">
                                                    请下载承诺书填写并上传,文件需要命名为【承诺书】
                                                </template>
                                                <a-icon type="exclamation-circle" />
                                            </a-tooltip>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 成果申报表明细表格 -->
                        <FGCollapsiblePanel title="江苏省优秀工程咨询成果评选申报表">
                            <vxe-toolbar size="mini">
                                <template v-slot:tools>
                                    <a-button type="primary" :loading="saving || loading" @click="insertCgsbbItem">增行</a-button>
                                </template>
                            </vxe-toolbar>
                            <vxe-table
                                ref="CGSBBitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataCGSBB"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column title="操作" width="120" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="removeCgsbbItem(scope.row)">删除</span>
                                        <span class="btn_edit" @click="editCgsbbItem(scope.row)">编辑</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    type="seq"
                                    title="序号"
                                    width="70"
                                    align="center"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xh" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="xmmc"
                                    title="成果名称"
                                    sortable
                                    header-class-name="required"
                                    show-overflow-tooltip="true"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xmmc" :maxLength="100" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="zymc"
                                    title="专业名称"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope">
                                        <a-input-search @search="showZy" v-model="scope.row.zymc" @change="cleanZYID(scope.row)" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cglx"
                                    title="成果类型"
                                    header-class-name="required"
                                    align="center"
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="cglx" dictNo="JC100601" v-model="scope.row.cglx" /> </template
                                ></vxe-table-column>
                                <!--                                <vxe-table-column-->
                                <!--                                    :edit-render="{-->
                                <!--                                        type: 'default',-->
                                <!--                                        autofocus: 'input'-->
                                <!--                                    }"-->
                                <!--                                    field="cgsbdj"-->
                                <!--                                    title="申报等级"-->
                                <!--                                    width="120"-->
                                <!--                                    header-class-name="required"-->
                                <!--                                    align="center"-->
                                <!--                                >-->
                                <!--                                    <template v-slot:edit="scope"><FGDictSelectCN ref="cgsbdj" dictNo="JC100602" v-model="scope.row.cgsbdj" /> </template-->
                                <!--                                ></vxe-table-column>-->
                                <!--                                <vxe-table-column-->
                                <!--                                    :edit-render="{-->
                                <!--                                        type: 'default',-->
                                <!--                                        autofocus: 'input'-->
                                <!--                                    }"-->
                                <!--                                    field="xmmj"-->
                                <!--                                    title="项目密级"-->
                                <!--                                    width="150"-->
                                <!--                                    header-class-name="required"-->
                                <!--                                    align="center"-->
                                <!--                                    ><template v-slot:edit="scope"><FGDictSelectCN ref="xmmj" dictNo="CG100102" v-model="scope.row.xmmj" /> </template-->
                                <!--                                ></vxe-table-column>-->
                                <!--                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cgkssj"
                                    title="成果开始时间"
                                    width="150"
                                    header-class-name="required"
                                    align="center"
                                    ><template v-slot:edit="scope">
                                        <a-date-picker
                                            ref="cgkssj"
                                            v-model="scope.row.cgkssj"
                                            width="100%"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                        /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cgwcsj"
                                    title="成果完成时间"
                                    width="150"
                                    header-class-name="required"
                                    align="center"
                                    ><template v-slot:edit="scope">
                                        <a-date-picker
                                            ref="cgwcsj"
                                            v-model="scope.row.cgwcsj"
                                            width="100%"
                                            valueFormat="YYYY-MM-DD"
                                            style="width:100%"
                                        /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="qtzywcdw"
                                    title="其他主要完成单位"
                                    width="200"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.qtzywcdw" :maxLength="100" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="nrty"
                                    title="内容提要（简明扼要介绍成果背景，工作过程，500字以内）"
                                    width="300"
                                    header-class-name="required"
                                    show-header-overflow="tooltip"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.nrty" :maxLength="1000" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cgtdjsbly"
                                    title="成果特点及申报理由（参照《关于2022年度江苏省优秀工程咨询成果水平评选的申报通知》所列的评选标准，直叙在申报成果中所做的咨询工作特点，要有利于评审专家和评委了解申报单位咨询工作的优秀之处。要求条理清晰，简明扼要，理由充分，特点突出。1500字以内。）"
                                    width="300"
                                    header-class-name="required"
                                    show-header-overflow="tooltip"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.cgtdjsbly" :maxLength="1500" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="spyjzy"
                                    title="审批（核准）意见摘要"
                                    width="300"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.spyjzy" :maxLength="200" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="pgyjzy"
                                    title="评估（评审、审查）意见摘要"
                                    width="300"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.pgyjzy" :maxLength="200" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="pjjdyjzy"
                                    title="评价、鉴定意见摘要"
                                    width="300"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.pjjdyjzy" :maxLength="200" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="qtzy"
                                    title="其他摘要"
                                    width="300"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.qtzy" :maxLength="200" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="sbdwyj"
                                    title="申报单位意见"
                                    width="300"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.sbdwyj" :maxLength="200" /> </template
                                ></vxe-table-column>-->
                                <!-- <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="wtdw"
                                    title="委托单位"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.wtdw" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="sfsm"
                                    title="是否涉密"
                                    width="150"
                                    header-class-name="required"
                                    ><template v-slot:edit="scope"><FGDictSelectCN ref="sfsm" dictNo="1101" v-model="scope.row.sfsm" required /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="fwfw"
                                    title="服务范围"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.fwfw" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="xmztz"
                                    title="项目总投资(万元)"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.xmztz" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="ghjb"
                                    title="规划级别"
                                    width="150"
                                    ><template v-slot:edit="scope"> <FGDictSelectCN ref="ghjb" dictNo="CG200103" v-model="scope.row.ghjb" required /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cggk"
                                    title="成果概况"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.cggk" /> </template
                                ></vxe-table-column>
                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="cgyyqk"
                                    title="成果应用情况"
                                    width="150"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.cgyyqk" /> </template
                                ></vxe-table-column> -->
                                <!--                                <vxe-table-column
                                    :edit-render="{
                                        type: 'default',
                                        autofocus: 'input'
                                    }"
                                    field="bz"
                                    title="备注"
                                    width="200"
                                    ><template v-slot:edit="scope"> <a-input size="small" v-model="scope.row.bz" :maxLength="200" /> </template
                                ></vxe-table-column>
                                <vxe-table-column title="成果相关附件" width="150" align="center">
                                    &lt;!&ndash; <template v-slot="scope">
                                        <UploadButton
                                            v-if="!scope.row.isnew"
                                            :ref="'uploadBtn' + scope.row.xh"
                                            :field="scope.row.id"
                                            :attachCfg="attachCfg_Edit"
                                            :btnType="2"
                                        />
                                    </template> &ndash;&gt;
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="zlmxInsert(scope.row)">上传</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="曾获奖励情况" width="160" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="hjqkmxInsert(scope.row)">添加</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column title="主要完成人情况（含排序）" width="175" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="wcrqkmxInsert(scope.row)">添加</span>
                                    </template>
                                </vxe-table-column>-->
                                <FGDataSelect :isShow.sync="isShow" selectNo="JC1002" @saveselect="saveEvent(arguments)"></FGDataSelect>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                    <!-- 流程跟踪组件 -->
                    <!-- <OperLog ref="operlog" :operLogProps="operLogProps"></OperLog> -->
                </a-layout-content>
                <!-- <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload ref="attachUpload" :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider> -->
            </a-layout>
        </a-page-header>
        <HjqkmxEdit :showHjqkmxEdit.sync="editProps.showHjqkmxEdit" :dataId="editProps.dataId" :cgsbbmxid="editProps.cgsbbmxid" @dataUpdated="loadData" />
        <WcrqkmxEdit :showWcrqkmxEdit.sync="editProps1.showWcrqkmxEdit" :dataId="editProps1.dataId" :cgsbbmxid="editProps1.cgsbbmxid" @dataUpdated="loadData" />
        <ZlmxEdit :showZlmxEdit.sync="editProps2.showZlmxEdit" :dataId="editProps2.dataId" :cgsbbmxid="editProps2.cgsbbmxid" @dataUpdated="loadData" />
        <CgsbcxmxEdit
            :showCgsbcxmxEdit.sync="editProps4.showCgsbcxmxEdit"
            :dataId="editProps4.dataId"
            :cgsbbmxid="editProps4.cgsbbmxid"
            @dataUpdated="loadData"
        />
    </div>
</template>

<script>
import HjqkmxEdit from "./HjqkmxEdit";
import WcrqkmxEdit from "./WcrqkmxEdit";
import ZlmxEdit from "./ZlmxEdit";
import CgsbcxmxEdit from "./CgsbcxmxEdit";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
import moment from "moment";
export default {
    name: "CgsbwhEdit",
    components: { CgsbcxmxEdit, HjqkmxEdit, WcrqkmxEdit, ZlmxEdit },
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            isShow: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataCGSBB: [],
            editItemDataCGSBBLoading: false,
            // 流程跟踪参数
            operLogProps: {
                visible: false,
                billid: null
            },
            editProps: {
                showHjqkmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps1: {
                showWcrqkmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps2: {
                showZlmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            },
            editProps4: {
                showCgsbcxmxEdit: false,
                dataId: null,
                cgsbbmxid: ""
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "编辑";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.id,
                attachsource: "CG1001"
            };
        },
        attachCfg_Edit() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.id,
                attachsource: "CG1001"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                bmid: this.getUserInfo.org_id,
                yhid: this.getUserInfo.id,
                djlxid: "CGSBB",
                ryid: this.getUserInfo.personnel_id,
                djzt: "制定",
                jdzt: "制定",
                apzt: "未安排",
                shzt: "未审核",
                zjxdzt: "未选定",
                cgsbbbh: "",
                lrbmmc: this.getUserInfo.org_name,
                lrrxm: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                sbrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                sbdwid: this.getUserInfo.companyInfo.id,
                sbdwbh: this.getUserInfo.companyInfo.dwbh,
                sbnf: 2024,
                sbdwmc: this.getUserInfo.companyInfo.dwmc,
                // zxdj: this.getUserInfo.companyInfo.zxdj
                dwlb: this.getUserInfo.companyInfo.dwlb
            };
            this.editItemDataCGSBB = [];
            this.$FG_helper.handleNewBillCode("CGSB").then((val) => {
                this.editData.cgsbbbh = val;
            });
        } else {
            // 修改，加载数据
            this.loadData(this.editDataId);
            // 加载明细数据
            this.loadItemDataCGSBB();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.cgsbbbh.focus();
        });
    },
    methods: {
        moment,
        showZy() {
            this.$refs.CGSBBitemTable.getCurrentRecord().zyid = null;
            this.$refs.CGSBBitemTable.getCurrentRecord().zymc = null;
            this.isShow = true;
        },
        saveEvent(val) {
            if (val && val.length > 0) {
                this.$refs.CGSBBitemTable.getCurrentRecord().zyid = val[0][0].ID;
                this.$refs.CGSBBitemTable.getCurrentRecord().zymc = val[0][0].ZYMC;
            }
        },
        cleanZYID(row) {
            if (row.zymc === null || row.zymc === "") {
                this.$refs.CGSBBitemTable.getCurrentRecord().zyid = null;
            }
        },
        //提交form
        onSave(btnType) {
            // 获取数据
            let CGSBBitemData = this.$refs.CGSBBitemTable.getTableData().tableData;
            let CGSBBitemRemovedData = [];
            if (btnType !== 2) {
                //验证必输项
                if (!this.editData.sbrq) {
                    this.$FG_message.error("P0001", "申报日期").then(() => this.$refs.sbrq.focus());
                    return;
                }
                if (!this.editData.sbnf) {
                    this.$FG_message.error("P0001", "申报年份").then(() => this.$refs.sbnf.focus());
                    return;
                }
                if (!this.editData.babh) {
                    this.$FG_message.error("P0001", "工程咨询单位备案编号").then(() => this.$refs.babh.focus());
                    return;
                }
                if (!this.editData.xxdz) {
                    this.$FG_message.error("P0001", "地址").then(() => this.$refs.xxdz.focus());
                    return;
                }
                if (!this.editData.yzbm) {
                    this.$FG_message.error("P0001", "邮政编码").then(() => this.$refs.yzbm.focus());
                    return;
                }
                if (!this.editData.lxr) {
                    this.$FG_message.error("P0001", "联系人1").then(() => this.$refs.lxr.focus());
                    return;
                }
                if (!this.editData.lxdh) {
                    this.$FG_message.error("P0001", "联系电话1").then(() => this.$refs.lxdh.focus());
                    return;
                }
                // if (!this.editData.lxr1) {
                //     this.$FG_message.error("P0001", "联系人2").then(() => this.$refs.lxr1.focus());
                //     return;
                // }
                // if (!this.editData.lxdh1) {
                //     this.$FG_message.error("P0001", "联系电话2").then(() => this.$refs.lxdh1.focus());
                //     return;
                // }
                for (let i = 0; i < CGSBBitemData.length; i++) {
                    if (!CGSBBitemData[i].xmmc) {
                        this.$FG_message.error("P0001", "成果名称").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].zymc) {
                        this.$FG_message.error("P0001", "专业名称").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].cglx) {
                        this.$FG_message.error("P0001", "成果类型").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    // if (!CGSBBitemData[i].cgsbdj) {
                    //     this.$FG_message.error("P0001", "申报等级").then(() => {
                    //         this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                    //     });
                    //     return;
                    // }
                    // if (!CGSBBitemData[i].xmmj) {
                    //     this.$FG_message.error("P0001", "项目密级").then(() => {
                    //         this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                    //     });
                    //     return;
                    // }
                    if (!CGSBBitemData[i].cgkssj) {
                        this.$FG_message.error("P0001", "成果开始时间").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].cgwcsj) {
                        this.$FG_message.error("P0001", "成果完成时间").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].qtzywcdw) {
                        this.$FG_message.error("P0001", "其他主要完成单位").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].nrty) {
                        this.$FG_message.error("P0001", "内容提要").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].cgtdjsbly) {
                        this.$FG_message.error("P0001", "成果特点及申报理由").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].spyjzy) {
                        this.$FG_message.error("P0001", "审批（核准）意见摘要").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].pgyjzy) {
                        this.$FG_message.error("P0001", "评估（评审、审查）意见摘要").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    if (!CGSBBitemData[i].pjjdyjzy) {
                        this.$FG_message.error("P0001", "评价、鉴定意见摘要").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                    // if (!CGSBBitemData[i].qtzy) {
                    //     this.$FG_message.error("P0001", "其他摘要").then(() => {
                    //         this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                    //     });
                    //     return;
                    // }
                    if (!CGSBBitemData[i].sbdwyj) {
                        this.$FG_message.error("P0001", "申报单位意见").then(() => {
                            this.$refs.CGSBBitemTable.setActiveRow(CGSBBitemData[i]);
                        });
                        return;
                    }
                }
                if (btnType === 1) {
                    let fileClass = document.getElementsByClassName("uploadBtn");
                    if (fileClass.length > 0) {
                        this.$FG_message.error("请上传文件").then(() => {
                            fileClass[0].focus();
                        });
                        return;
                    }
                }
            }
            // 保存操作
            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/save",
                    {
                        data: this.editData,
                        CGSBBitemData,
                        CGSBBitemRemovedData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        CGSBBitemData.forEach((item, index) => {
                            item.isnew = false;
                        });
                        if (btnType === 1) {
                            this.submit();
                        } else {
                            this.loadData(this.editData.id);
                        }
                    } else {
                        this.$refs.cgsbbbh.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/zxcggl/cgsbgl/submit", {
                            id: this.editData.id
                            //,tjrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss")
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                //提交之后跳转主页面
                                this.editIsVisible = false;
                            } else {
                                this.$refs.cgsbbbh.focus();
                            }
                        });
                }
            });
        },
        insertCgsbbItem() {
            // 设置编辑记录
            let xh = this.$refs.CGSBBitemTable.getTableData().tableData.length + 1;
            // 主表未保存不允许增行
            if (this.editData.isnew) {
                this.$FG_message.error("请先保存主表！").then(() => {});
                return;
            }
            if (this.editData.dwlb) {
                if (
                    (this.editData.dwlb === "会长单位" ||
                        this.editData.dwlb === "副会长单位" ||
                        this.editData.dwlb === "监事单位" ||
                        this.editData.dwlb === "监事会主席单位") &&
                    xh > 10
                ) {
                    this.$FG_message.error("可申报的成果不能超过10项！").then(() => {});
                    return;
                }
                if (this.editData.dwlb === "常务理事单位" && xh > 6) {
                    this.$FG_message.error("可申报的成果不能超过6项！").then(() => {});
                    return;
                }
                if (this.editData.dwlb === "理事单位" && xh > 3) {
                    this.$FG_message.error("可申报的成果不能超过3项！").then(() => {});
                    return;
                }
                if (this.editData.dwlb === "一般会员" && xh > 2) {
                    this.$FG_message.error("可申报的成果不能超过2项！").then(() => {});
                    return;
                }
            } else {
                if (xh > 2) {
                    this.$FG_message.error("可申报的成果不能超过2项！").then(() => {});
                    return;
                }
            }
            // this.$refs.CGSBBitemTable.insertAt(
            //     {
            //         isnew: true,
            //         id: this.$FG_util.uuid(),
            //         cgsbbid: this.editData.id,
            //         xh: xh,
            //         xmztz: 0,
            //         tjbj: 0,
            //         mxzt: "专家未选定"
            //     },
            //     -1
            // ).then(({ row }) => {
            //     this.$refs.CGSBBitemTable.setActiveRow(row);
            // });
            // 设置编辑记录id
            this.editProps4.dataId = this.editData.id;
            this.editProps4.cgsbbmxid = null;
            // 显示编辑窗口
            this.editProps4.showCgsbcxmxEdit = true;
        },
        // 删除明细
        removeCgsbbItem(row) {
            this.$FG_message.confirm("P0000", "删除").then((type) => {
                if (type === "ok") {
                    if (row.isnew === true) {
                        this.$refs.CGSBBitemTable.remove(row);
                    } else {
                        this.editItemDataCGSBBLoading = true;
                        this.$FG_http
                            .post("./api/main/zxcggl/cgsbgl/deleteCgsbbMx", {
                                id: row.id
                            })
                            .then(({ success, data, errMsg }) => {
                                this.editItemDataCGSBBLoading = false;
                                if (success) {
                                    this.loadItemDataCGSBB();
                                    this.$refs["uploadBtn" + row.xh].handleRemove(true);
                                }
                            });
                    }
                }
            });
        },
        //单击明细列表展示明细详情
        editCgsbbItem(row) {
            // 设置编辑记录id
            this.editProps4.dataId = this.editData.id;
            this.editProps4.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps4.showCgsbcxmxEdit = true;
        },
        loadData(id) {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/selectById",
                    {
                        id: id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            this.loadItemDataCGSBB();
                            // this.initOperLog();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataCGSBB() {
            this.editItemDataCGSBB = [];
            this.editItemDataCGSBBLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemCGSBB",
                    {
                        cgsbbid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataCGSBBLoading = false;
                    if (success) {
                        this.editItemDataCGSBB = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        // 资料明细
        zlmxInsert(row) {
            //先保存
            if (row.isnew) {
                this.onSave(2);
            }
            // 设置编辑记录id
            this.editProps2.dataId = this.editData.id;
            this.editProps2.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps2.showZlmxEdit = true;
        },
        // 获奖情况明细
        hjqkmxInsert(row) {
            // 设置编辑记录id
            this.editProps.dataId = this.editData.id;
            this.editProps.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps.showHjqkmxEdit = true;
        },
        // 完成人情况明细
        wcrqkmxInsert(row) {
            // 设置编辑记录id
            this.editProps1.dataId = this.editData.id;
            this.editProps1.cgsbbmxid = row.id;
            // 显示编辑窗口
            this.editProps1.showWcrqkmxEdit = true;
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        },
        //加载操作日志
        initOperLog() {
            this.operLogProps.visible = true;
            this.operLogProps.billid = this.editData.id;
        },
        refreshAttach() {
            this.$refs.attachUpload.queryAttachFileList();
            let data = this.$refs.CGSBBitemTable.getTableData().tableData;
            data.forEach((item) => {
                this.$refs["uploadBtn" + item.xh].queryAttachFileList(true);
            });
        },
        //下载模板-承诺书
        downLoadImportModel() {
            let xieyi = window.location.href.split("://")[0];
            let host = window.location.host;
            let pathname = window.location.pathname;
            let baseUrl = xieyi + "://" + host + pathname;
            const link = document.createElement("a");
            link.style.display = "none";
            link.setAttribute("href", baseUrl + "/static/files/Template.docx");
            link.download = "承诺书" + new Date().getTime(); //下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>
<style lang="scss" scoped>
.collapsible-panel-title {
    width: 100%;
    height: 20px;
    margin: 24px 0 0 0;
    display: flex;

    .collapsible-panel-title-txt {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #1e202d;
        border-left: 5px solid #33cde5;
        padding: 0 8px;
    }

    .collapsible-panel-title-content {
        font-size: 14px;
        height: 20px;
        color: #f77824fb;
        background-color: #f5ece4;
    }
}
</style>
